import { request, publicRequest } from '@/utils/request'


// 查询问诊列表
export function getAlipay(query) {
  return request({
    url: '/base/product/order/getPayPage',
    method: 'get',
    params: query
  })
}

// 新增
// export function addBulletin(data) {
//   return publicRequest({
//     url: '/msgcenter/notice/save',
//     method: 'post',
//     data: data
//   })
// }